// useAgentsQuery — load the agent catalog as a TanStack Query.
//
// The query function is built from the injected `AgentsApiClient`. The
// hook never reads from `fetch`, storage, or another slice's internals.
//
// View-model mapping happens inside the query function so the cache
// stores the camelCase `AgentCatalogView` — components never see the
// wire shape.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useAgentsApiClient } from '../api/useAgentsApiClient';
import { agentKeys } from './queryKeys';
import { toAgentCatalogView } from './toAgentView';
import type { AgentCatalogView } from './types';

export function useAgentsQuery(): UseQueryResult<AgentCatalogView> {
  const client = useAgentsApiClient();
  return useQuery<AgentCatalogView>({
    queryKey: agentKeys.catalog(),
    queryFn: async ({ signal }) => {
      const raw = await client.fetchCatalog(signal);
      return toAgentCatalogView(raw);
    },
  });
}
